import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import Card from 'components/inputs/Card';
import { MdClose } from 'react-icons/md';
import { Row, Col } from 'react-bootstrap';
import { Formik, Form } from 'formik';
import TextInput from 'components/inputs/Input';
import Button from 'components/inputs/Button';
import _ from 'lodash';
import * as Yup from 'yup';
import { useDispatch, useSelector } from 'react-redux';
import { CREATE_OEM_VENDOR, UPDATE_OEM_VENDOR } from 'actions/oemVendor';
import { CREATE_STATUS_CODE, UPDATE_STATUS_CODE } from '../../../components/common/constant';

const OemVendorSchema = Yup.object().shape({
  name: Yup.string()
    .required('OEM vendor name is required')
    .max(100, 'name must be at maximum 100 characters')
    .strict(true)
    .trim('Space is not allowed')
    .matches(/^([^0-9]*)$/, 'Only characters and special characters are allowed')
    .max(100, 'Text limit should be less than 100 characters'),
});

const OemVendorForm = (props) => {
  const { isEdit, onClose = _.noop(), onSuccess = _.noop() } = props;
  const dispatch = useDispatch();

  const oemVendorDetail = useSelector((state) => state.oemVendor.oemVendorDetail);
  const isLoading = useSelector((state) => state.oemVendor.isLoading);

  const addOemVendor = useCallback((data) => {
    dispatch({
      type: CREATE_OEM_VENDOR,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === CREATE_STATUS_CODE) {
          onSuccess();
          onClose();
        }
      },
    });
  }, []);

  const updateOemVendor = useCallback((data) => {
    dispatch({
      type: UPDATE_OEM_VENDOR,
      payload: data,
      cb: (res) => {
        if (_.get(res, 'status') === UPDATE_STATUS_CODE) {
          onClose();
        }
      },
    });
  }, []);

  const initialValues = isEdit
    ? oemVendorDetail
    : {
        name: '',
      };

  return (
    <React.Fragment>
      <div className="oemVendor-form-page__main">
        <Card>
          <div className="oemVendor-form-header__block">
            <div className="oemVendor-header-name">
              <span>{isEdit ? 'Edit' : 'Add'} OEM</span>
            </div>
            <div className="close_btn">
              <MdClose size={30} color="#be210b" onClick={onClose} />
            </div>
          </div>
          <div className="oemVendor-form-body__block">
            <div className="oemVendor-form--block">
              <Formik
                enableReinitialize={!!isEdit}
                initialValues={initialValues}
                validationSchema={OemVendorSchema}
                onSubmit={(values, { setSubmitting }) => {
                  if (isEdit) {
                    updateOemVendor(values);
                  } else {
                    addOemVendor(values);
                  }
                  setSubmitting(false);
                }}
              >
                {({ values, errors, touched, handleSubmit, handleChange, isSubmitting }) => (
                  <Form onSubmit={handleSubmit}>
                    <Row>
                      <Col lg={12} md={12}>
                        <TextInput
                          isRequired
                          label="OEM"
                          placeholder="OEM"
                          name="name"
                          value={_.get(values, 'name', '')}
                          onChange={handleChange}
                          error={errors.name && touched.name ? errors.name : null}
                        />
                      </Col>
                    </Row>
                    <div className="form_btn__block">
                      <Button className="form__btn cancel--btn" onClick={onClose}>
                        Cancel
                      </Button>
                      <Button type="submit" disabled={isSubmitting || isLoading} className="form__btn">
                        {isEdit ? 'Edit' : 'Add'}
                      </Button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </div>
        </Card>
      </div>
    </React.Fragment>
  );
};
OemVendorForm.propTypes = {
  onClose: PropTypes.func,
  isEdit: PropTypes.bool,
  onSuccess: PropTypes.func,
};
export default OemVendorForm;
